import { getOrderList, cancelOrder } from '@fetch/order.js';
import { fetchGoodsTags } from '@fetch';
import { orderStatusForOrderList as orderStatus } from '@utils/config/order';

const state = {
  orderList: [],
  pageInfo: {
    currPage: 1,
    pagesize: 10,
    totalCount: 0,
  },
  unpaidAmount: 0,
  loading: true,
  lock: false,
};

const getters = {
  getOrderList: (state) => {
    if (!state.orderList) return [];
    return state.orderList.map(item => {
      orderStatus.map(itemState => {
        if (item.orderStatus === itemState.status)
          item = { ...item, ...itemState };
        return item;
      });
      return item;
    });
  },
};

const actions = {
  getOrderList({ commit }, data) {
    getOrderList(data)
      .then(res => {
        if (res.code) return;
        let goodsList = [];
        if (res.orderList && res.orderList.length > 0) {
          res.orderList.forEach(item => {
            item.goodsList && item.goodsList.length > 0 && item.goodsList.forEach(goods => {
              if (goods.goodsId && goods.categoryId) {
                goodsList.push({ goodsId: goods.goodsId, categoryId: goods.categoryId })
              }
            })
          })
          if (goodsList.length > 0) {
            fetchGoodsTags({ goodsList, channel: 2 }).then(tagRes => {
              if (tagRes && tagRes.length > 0) {
                res.orderList.forEach(item => {
                  item.goodsList.forEach(goods => {
                    const goodTag = tagRes.find(tag => tag.categoryId == goods.categoryId && tag.goodsId == goods.goodsId);
                    let tags = goodTag && goodTag.tags ? goodTag.tags : [];
                    // 爆炸贴数据
                    let stickerImgList = tags.filter(item => item.type === 2);
                    goods.stickerImgList = stickerImgList;
                    goods.tags = tags;
                  });
                });
                commit('setLoading', false);
                commit('setOrderList', JSON.parse(JSON.stringify(res)));
                commit('setPageInfo', res);
                commit('setAmount', res);
              } else {
                commit('setLoading', false);
                commit('setOrderList', res);
                commit('setPageInfo', res);
                commit('setAmount', res);
              }
            });
          } else {
            commit('setLoading', false);
            commit('setOrderList', res);
            commit('setPageInfo', res);
            commit('setAmount', res);
          }
        } else {
          commit('setLoading', false);
          commit('setOrderList', res);
          commit('setPageInfo', res);
          commit('setAmount', res);
        }


      });
  },
  cancelOrder({ commit, state }, data) {
    const { lock } = state;
    !lock &&
      cancelOrder(data).then(res => {
        res ? data.success() : data.error();
        commit('setLock', false);
      });
    commit('setLock', true);
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setLock(state, value) {
    state.lock = value;
  },
  setOrderList(state, { orderList }) {
    state.orderList = orderList;
  },
  setPageInfo(state, { currPage, pagesize, totalCount }) {
    state.pageInfo = { currPage, pagesize, totalCount };
  },
  setAmount(state, { unpayCount }) {
    state.unpaidAmount = unpayCount;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
